import { Block } from 'webiq.boilerplate'

export default class ShoppingcartPopupProduct extends Block {
	static title = 'shoppingcart-popup-product'

	init() {
		this.inputElement = this.element.querySelector('[name="count"]')
		if (this.inputElement) {
			this.inputElement.addEventListener('change', () =>
				this.editCount(this.inputElement.value),
			)
		}

		this.removeButton = this.getElement('delete')
		if (this.removeButton) {
			this.removeButton.addEventListener('click', () => this.editCount(0))
		}

		this.productCount = this.getElement('count')

		this.input = this.getElement('input')
		this.plus = this.element.querySelector('[data-plus]')
		this.min = this.element.querySelector('[data-min]')
		this.amount = null

		if (this.plus) {
			this.plus.addEventListener('click', () => {
				this.plus.style.pointerEvents = 'none'
				this.amount = this.input.value
				this.input.value = parseInt(this.input.value, 10) + 1
				this.editCount(this.input.value, this.amount)
			})
		}

		if (this.min) {
			this.min.addEventListener('click', () => {
				this.min.style.pointerEvents = 'none'
				this.amount = this.input.value
				this.input.value = Math.max(parseInt(this.input.value, 10) - 1, 0)
				this.editCount(this.input.value, this.amount)
			})
		}

		if (this.input !== null) {
			this.input.addEventListener('keyup', () => {
				if (!this.input.max) {
					return
				}
				this.input.value = Math.min(
					parseInt(this.input.value, 10),
					this.input.max,
				)
			})

			this.input.addEventListener('change', () => {
				this.editCount(this.input.value, null)
			})
		}
	}

	ga4Datalayer(type) {
		// GA4
		if ('dataLayer' in window) {
			window.dataLayer.push({ ecommerce: null })
			window.dataLayer.push({
				shoppingcartId: parseInt(document.querySelector('input[name="analytics-id"]').value),
				event: type,
				ecommerce: {
					currency: "EUR",
					currency_user: this.element.getAttribute('data-currency') ? this.element.getAttribute('data-currency') : "EUR",
					value: parseFloat(this.element.getAttribute('data-product-price')),
					value_user: parseFloat(this.element.getAttribute('data-product-price-user')),
					items: [
						{
							item_id: this.element.getAttribute('data-product-ean') ? this.element.getAttribute('data-product-ean') : this.element.getAttribute('data-product-id'),
							item_group_id: this.element.getAttribute('data-product-id'),
							item_name: this.element.getAttribute('data-product-name'),
							price: parseFloat(this.element.getAttribute('data-product-price')),
							price_user: parseFloat(this.element.getAttribute('data-product-price-user')),
							item_brand: this.element.getAttribute('data-product-brand'),
							item_category: this.element.getAttribute('data-product-category'),
							item_variant: this.element.getAttribute('data-product-variant'),
							quantity: 1,
							google_business_vertical: "retail",
							id: this.element.getAttribute('data-product-ean') ? this.element.getAttribute('data-product-ean') : this.element.getAttribute('data-product-id'),
						},
					],
				},
			})
		}
	}

	editCount(count, amount) {
		this.removeButton.classList.add(
			'shoppingcart-popup-product__delete--disabled',
		)
		this.plus.style.pointerEvents = 'none'
		this.min.style.pointerEvents = 'none'
		this.input.style.pointerEvents = 'none'
		const payload = new FormData()
		payload.append('update', true)
		payload.append('product_id', this.element.getAttribute('data-shoppingcart-product-id'))
		payload.append('count', count)
		payload.append('ajax', true)

		fetch('/shoppingcart', {
			method: 'POST',
			body: payload,
			credentials: 'same-origin',
		})
			.then((response) => response.json())
			.then((json) => {
				if (json.error) {
					return
				}

				if (this.inputElement && count > 0) {
					this.inputElement.value = count
				}

				if (this.productCount) {
					this.productCount.textContent = count
				}

				if (count === 0) {
					this.ga4Datalayer('remove_from_cart')
				}

				window.eventEmitter.emit('shoppingcart-popup-product:update', json)
				this.min.style.pointerEvents = 'initial'
				this.plus.style.pointerEvents = 'initial'

				this.removeButton.classList.remove(
					'shoppingcart-popup-product__delete--disabled',
				)

				if(amount < count) {
					this.ga4Datalayer('add_to_cart')
				}

				if(amount > count) {
					this.ga4Datalayer('remove_from_cart')
				}
			})
			.catch((error) => this.handleError(error))
	}
}
